/**
 * Utilities for handling environment variables in Vite + TypeScript.
 */
export const env = {
  mode: import.meta.env.MODE,
  appEnv: import.meta.env.VITE_APP_ENV ?? import.meta.env.MODE,
  isViteDev: import.meta.env.DEV,
  isViteBuild: import.meta.env.PROD,

  get isDev() {
    return this.isViteDev || this.appEnv === 'development' || this.appEnv === 'mock'
  },

  get isMock() {
    return this.appEnv === 'mock'
  },

  get isProd() {
    return this.appEnv === 'production'
  },

  get isStaging() {
    return this.appEnv === 'staging'
  },
}
